import { render, staticRenderFns } from "./Transportation.vue?vue&type=template&id=379e5cf6&scoped=true"
import script from "./Transportation.vue?vue&type=script&lang=js"
export * from "./Transportation.vue?vue&type=script&lang=js"
import style0 from "./Transportation.vue?vue&type=style&index=0&id=379e5cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379e5cf6",
  null
  
)

export default component.exports